export default {
  title: 'Feature Flags',
  subtitle: 'Enable or disable platform features for {{company}}.',
  no_company: 'Select a restaurant to manage its feature flags.',
  columns: {
    feature: 'Feature',
    status: 'Status',
  },
  flags: {
    paypal_standalone: {
      name: 'PayPal (direct)',
      description:
        "Let this restaurant take PayPal payments directly into their own PayPal account. On by default for restaurants of partners billed by Foodamigos, where the customer service fee is also charged on these payments and the platform's share is billed to the partner.",
    },
    vip_free_flyers: {
      name: 'Monthly free flyers',
      description:
        'Automatically send 500 promotional flyers each month to this restaurant (default: on for VIP and Star tier).',
    },
    custom_store_seo: {
      name: 'Custom store SEO',
      description: 'Let this restaurant manage the custom SEO settings for their online shop.',
    },
    external_printer: {
      name: 'External receipt printer',
      description:
        'Let this restaurant connect a network receipt printer to the order terminal app, instead of printing on the terminal’s built-in printer.',
    },
    stripe_payment_element: {
      name: 'Stripe Payment Element checkout',
      description:
        'Let the restaurant’s own Stripe account decide which payment methods the checkout offers. Switch it on only once its Stripe platform has the payment methods for connected accounts set up.',
    },
  },
  toasts: {
    enabled: 'Feature enabled.',
    disabled: 'Feature disabled.',
    error: 'Could not update the feature. Please try again.',
    load_error: 'Could not load feature flags.',
  },
};
